module.exports = __webpack_public_path__ + "img/22200.f967ba5a.jpg";